import Raven from 'raven-js';
const HUBSPOT_INTERNAL_PORTAL = 53;
const DRAFTS_SEGMENT = 'drafts';
const P53_CONTACT_ID = 'p53_contact_id';
const MAX_ATTRIBUTION_VALUE_LENGTH = 256;
const ATTRIBUTION_TRACKING_PARAMS = ['source_app', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'meeting_campaign'];
const ALLOWED_QUERY_PARAMS = ['meeting_origin_link_53'];
const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/;
const URL_PATTERN = /^[a-z][a-z0-9+.-]*:\/\//i;
const LONG_DIGIT_RUN_PATTERN = /\d{9,}/;
const looksLikePii = value => EMAIL_PATTERN.test(value) || URL_PATTERN.test(value) || LONG_DIGIT_RUN_PATTERN.test(value);
const stripUrlQueryString = value => {
  try {
    const parsed = new URL(value);
    return `${parsed.origin}${parsed.pathname}`;
  } catch (e) {
    return value;
  }
};
const removeDraftsSegment = segments => {
  const draftsIndex = segments.findIndex(segment => segment.toLowerCase() === DRAFTS_SEGMENT);
  if (draftsIndex === -1) {
    return {
      segments
    };
  }
  return {
    segments: [...segments.slice(0, draftsIndex), ...segments.slice(draftsIndex + 2)],
    contactIdSegment: segments[draftsIndex + 1]
  };
};
export const getTrackingParamsAttribution = trackingParams => {
  const attribution = {};
  ATTRIBUTION_TRACKING_PARAMS.forEach(key => {
    const value = trackingParams[key];
    if (value) {
      const stringValue = String(value);
      if (!looksLikePii(stringValue)) {
        attribution[key] = stringValue.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
      }
    }
  });
  return attribution;
};
export const getUrlAttributionParams = ({
  slug,
  portalId
}) => {
  const attribution = {};
  try {
    const {
      segments,
      contactIdSegment
    } = removeDraftsSegment((slug || '').split('/').filter(Boolean));
    const meetingSlug = segments.join('/');
    if (meetingSlug) {
      attribution['meeting_slug'] = meetingSlug;
    }
    if (portalId === HUBSPOT_INTERNAL_PORTAL && contactIdSegment && /^\d+$/.test(contactIdSegment)) {
      attribution[P53_CONTACT_ID] = contactIdSegment;
    }
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (value && ALLOWED_QUERY_PARAMS.includes(key)) {
        const strippedValue = stripUrlQueryString(value);
        if (!EMAIL_PATTERN.test(strippedValue) && !LONG_DIGIT_RUN_PATTERN.test(strippedValue)) {
          attribution[key] = strippedValue.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
        }
      }
    });
  } catch (e) {
    Raven.captureException(e, {
      extra: {
        message: 'unable to extract url attribution params for meetings usage event'
      }
    });
  }
  return attribution;
};